import { useCallback, useEffect, useState } from 'react'
import type { ProjectMixStats } from '../types/projectAnalysis'

export function useProjectMixStats() {
  const [data, setData] = useState<ProjectMixStats | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [reloadToken, setReloadToken] = useState(0)

  const refetch = useCallback(() => {
    setReloadToken((t) => t + 1)
  }, [])

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)
    fetch('/json-data/project_mix_stats.json')
      .then((r) => {
        if (!r.ok) throw new Error('Project mix stats not found')
        return r.json() as Promise<ProjectMixStats>
      })
      .then((d) => {
        if (!cancelled) setData(d)
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message || 'Failed to load stats')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [reloadToken])

  return { data, loading, error, refetch }
}
